import { render, staticRenderFns } from "./ProgramItem.vue?vue&type=template&id=4595c904&scoped=true"
import script from "./ProgramItem.vue?vue&type=script&lang=js"
export * from "./ProgramItem.vue?vue&type=script&lang=js"
import style0 from "./ProgramItem.vue?vue&type=style&index=0&id=4595c904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595c904",
  null
  
)

export default component.exports